const INTEGER_PATTERN = /^[+-]?\d+$/;
export const INT64_RANGE_MESSAGE =
    'Value out of 64 bit integer range. Enter an integer from -9,223,372,036,854,775,808 to 9,223,372,036,854,775,807.';

export function int64Validator(control: { value: unknown }): Record<string, boolean> | null {
    const text = String(control.value ?? '');
    if (text === '') return null;
    if (!INTEGER_PATTERN.test(text)) return { integer: true };

    const value = BigInt(text);
    return value < -9223372036854775808n || value > 9223372036854775807n
        ? { int64Range: true }
        : null;
}
